import React, { useEffect, useState } from "react";
import Header from "../../../Header/Header";
import Footer from "../../../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import "./DesignBoxEditedPreview.css";
import styles from "./DesignBoxEditedPreviewImgContainer.module.css";
import LineBtnImg from "../../../../assets/images/icons/line_bar_icon.png";
import useAxios from "../../../Hooks/useAxios";
import OrderEditUserImageBox from "./OrderEditUserImageBox";
import AddressPopupContent from "../../../Reusables/AddressPopupContent/AddressPopupContent";
import { linkProfile } from "../../../../constants";

const backend_base = process.env.REACT_APP_API_BASE_URL;

const DesignBoxEditedPreview = () => {
  const location = useLocation();
  const axios = useAxios();
  const { state } = location;
  const id = state?.item?.id;
  console.log(id, "order item id");
  const [item, setItem] = useState({});
  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + id)
      .then((res) => {
        console.log(res.data);
        setItem(res.data);
      })
      .catch((e) => {
        alert(e.message);
        console.log(e.message);
      });
  }, []);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const handleOpenAddressPopup = () => {
    setShowAddressPopup((prev) => !prev);
  };
  if (!state) {
    return (
      <>
        <Header />
        <div>No data availabe for this product.</div>;
        <Footer />
      </>
    );
  }
  // const { item } = state;
  console.log(item, "item from edited design preview");
  return (
    <>
      <Header />
      <div className="edited-preview">
        <TopDiv
          quantity={item?.quantity}
          addresString={item?.address_str}
          handleOpenAddressPopup={handleOpenAddressPopup}
          productName={item?.product?.product_category?.name}
          productType={item?.product?.product_type}
          sizePages={item?.product?.size_page}
        />
        <MiddleImgContainerDiv item={item} />
        <BottomDiv />
        {showAddressPopup && (
          <AddressPopupContent
            item={item}
            handleOpenAddressPopup={handleOpenAddressPopup}
          />
        )}
      </div>
      <Footer />
    </>
  );
};

const TopDiv = ({
  quantity,
  addresString,
  handleOpenAddressPopup,
  productType,
  sizePages,
  productName,
}) => {
  return (
    <div className="top-div-container">
      <p className="d-flex flex-column align-items-center justify-content-center p-0 m-0 top-div-text">
        <span>{productName}</span>
        <span>
          {productType}
          {sizePages}
        </span>
      </p>
      <div className="top-div-text top-div-item-margin">X</div>
      <div className="top-div-text top-div-item-margin">個数　{quantity}</div>
      <div className="top-div-address">
        <div className="d-flex justify-content-around top-div-text">
          <span
            className="address-design-text"
            style={{ alignSelf: "flex-end" }}
          >
            配送先
          </span>
          <div className="address-design address-design-text d-flex align-items-center justify-content-center">
            {addresString}
          </div>
        </div>
        <button
          className="btn address-design-link mt-2 d-block"
          style={{ backgroundColor: "none", background: "none" }}
          onClick={handleOpenAddressPopup}
        >
          お届け先を確認
        </button>
      </div>
    </div>
  );
};

const MiddleImgContainerDiv = ({ item }) => {
  const { design } = item;
  console.log(design);
  const productCatName = item?.product?.product_category.name;
  console.log(productCatName);
  const prevImg = design?.preview_image;
  console.log(prevImg?.length);
  return (
    <div className="img-div pb-5">
      <div className="img-div-header d-flex justify-content-center align-items-center">
        入稿データ
      </div>
      {prevImg?.length > 1 && (
        <img
          style={{ display: "block", marginBottom: "100px" }}
          src={backend_base + prevImg}
          className="img-fluid m-auto"
          alt="preview"
        />
      )}
      {prevImg?.length === 1 && productCatName === "ポストカード" && (
        <PostCardPattern design={design} />
      )}
      {prevImg?.length === 1 && productCatName === "パーツフォト" && (
        <div style={{ textAlign: "center" }}>
          このアイテムには表示する画像がありません。
        </div>
      )}
      {prevImg?.length === 1 && productCatName === "プリント" && (
        <PrintPattern design={design} />
      )}
      {prevImg?.length === 1 && productCatName === "カレンダー" && (
        <CalendarPattern design={design} />
      )}
      {productCatName === "年賀状" && <NewYearsCardPattern design={design} />}
    </div>
  );
};

const BottomDiv = () => {
  const navigate = useNavigate();
  return (
    <div className="bottom-div-container">
      <div className="bottom-div-container-top">
        <p className="text-on-top-line">
          入稿後の編集はできません。変更希望がある場合はLINEにてお知らせください。
        </p>
        <div>
          <a href={linkProfile} target="_blank" rel="noopener noreferrer">
            <img
              className="line-btn-img"
              src={LineBtnImg}
              width={230}
              height={54}
              alt="line"
            />
          </a>
        </div>
      </div>
      <div>
        <button
          className="btn return-btn mt-5 mx-auto d-block"
          onClick={() => {
            navigate("/design-box?activeTab=2");
          }}
        >
          戻る
        </button>
      </div>
    </div>
  );
};

const PostCardPattern = ({ design }) => {
  let designDetails = {};
  if (design) {
    designDetails =
      typeof design?.design_details === "string"
        ? JSON.parse(design?.design_details)
        : design?.design_details;
  }
  const imagesArray = designDetails?.images;
  console.log(imagesArray);
  // // Filter out items with empty src
  const filteredImages = imagesArray?.filter((image) => image?.src?.length > 0);
  console.log(filteredImages);
  // Map the filtered images to the desired format
  const resultArray = filteredImages.map((image) => ({
    url: image.src,
    count: image.count,
  }));
  console.log(resultArray);
  return (
    <div className={styles.editPattern1Container}>
      <UserImageWithCount
        width={"330px"}
        height={"330px"}
        images={resultArray}
        imagesPerRow={2}
        showCount={true}
      />

      <div className="d-flex flex-column align-items-start my-5"></div>
    </div>
  );
};
const UserImageWithCount = ({ images, width, height, showCount = false }) => {
  return (
    <div
      className="d-flex flex-wrap my-5 justify-content-center"
      style={{ gap: "50px" }}
    >
      {images.map((imageItem, index) => (
        <div key={index} className={styles.userImageContainer}>
          <div
            style={{
              backgroundColor: "#f2f2f2",
              padding: "50px 0",
              width: "330px",
              height: "330px",
              borderRadius: "11px",
            }}
          >
            <img
              src={imageItem.url}
              alt={`${index + 1}`}
              className={styles.postCardImage}
              width={width}
              height={height}
            />
          </div>
          {showCount && (
            <div className={styles.countOverlay}>
              <span>
                {imageItem.count}
                {` `}枚
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const PrintPattern = ({ design }) => {
  let designDetails = {};
  if (design) {
    designDetails =
      typeof design?.design_details === "string"
        ? JSON.parse(design?.design_details)
        : design?.design_details;
  }
  return (
    <div className={styles.editPattern1Container}>
      <OrderEditUserImageBox
        width={"500px"}
        height={"500px"}
        imageUrls={[designDetails?.src]}
        imagesPerRow={1}
      />
    </div>
  );
};

const CalendarPattern = ({ design }) => {
  let designDetails = {};
  if (design) {
    designDetails =
      typeof design?.design_details === "string"
        ? JSON.parse(design?.design_details)
        : design?.design_details;
  }
  const urlList = designDetails?.images
    .flat() // Flatten the nested arrays into a single array
    .map((image) => image.src);

  return (
    <div className={styles.grid_container}>
      {urlList.map((src, index) => {
        return (
          <div className={styles.grid_item}>
            <div className={styles.image_body_main_div}>
              <img className={styles.image_body_image} src={src} alt={src} />
            </div>
            <p className={styles.sheetText}>{index + 1 + " 枚目"}</p>
          </div>
        );
      })}
    </div>
  );
};

const NewYearsCardPattern = ({ design }) => {
  let designDetails = {};
  if (design) {
    designDetails =
      typeof design?.design_details === "string"
        ? JSON.parse(design?.design_details)
        : design?.design_details;
  }
  const imagesArray = designDetails?.images;
  console.log(imagesArray);
  // // Filter out items with empty src
  const filteredImages = imagesArray?.filter((image) => image?.src?.length > 0);
  console.log(filteredImages);
  // Map the filtered images to the desired format
  const resultArray = filteredImages.map((image) => ({
    src: image.src,
  }));
  console.log(resultArray);
  return (
    <div className={styles.image_container_main}>
      {resultArray.map((item, index) => {
        if (item.src) {
          return (
            <div className={styles.image_single_container} key={index}>
              <div
                className={styles.image_main_div}
                style={{
                  backgroundColor: "rgba(204, 204, 204, 0.23)",
                }}
              >
                <img
                  src={item.src}
                  className={styles.edit_image}
                  alt="edit img"
                />
              </div>
            </div>
          );
        } else {
          return <div></div>;
        }
      })}
    </div>
  );
};

export default DesignBoxEditedPreview;
